module.exports = __webpack_public_path__ + "static/media/logo.00c6b71e.png";